import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, keywords }) {
  const appName = import.meta.env.VITE_APP_NAME || 'Paise Ki Pathshala';
  const fullTitle = title ? `${title} | ${appName}` : `${appName} - Our Money. Our Plan. Our Future.`;
  const desc = description || 'Learn personal finance in simple Marathi and English. Beginner-friendly financial education for Indian users.';
  const kw = keywords || 'finance, marathi, money, savings, investment, india';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={kw} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
    </Helmet>
  );
}
